import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./assets/scss/styles.scss";
import Header from "./components/Header/Header";
import Intro from "./components/Intro/Intro";
import Presencia from "./components/Presencia/Presencia";
import Socios from "./components/Socios/Socios";
import Clientes from "./components/Clientes/Clientes";
import Contacto from "./components/Contacto/Contacto";
import Trabajo from "./components/Trabajo/Trabajo";
import Footer from "./components/Footer/Footer";
import Proteccion from "./components/Proteccion/Proteccion";
import Familia from "./components/Familia/Familia";
import Hogar from "./components/Hogar/Hogar";

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/">
          <Header />
          <Intro />
          <Proteccion />
          <Familia />
          <Presencia />
          <Hogar />
          <Socios />
          <Clientes />
          <Contacto />
          <Footer />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;

